/**
 * The name of the MFE as defined in the package.json.
 *
 * @See webpack.config.js DefinePlugin() section for this variable declaration and value definition.
 */
declare const PACKAGE_JSON_APPLICATION_NAME: string;
declare const PACKAGE_JSON_APPLICATION_VERSION: string;

/**
 * It exposes the package.json file values to the application as constants.
 */
export class PackageJsonFileValues {
  static readonly APPLICATION_NAME = PACKAGE_JSON_APPLICATION_NAME;
  static readonly APPLICATION_VERSION = PACKAGE_JSON_APPLICATION_VERSION;
}
